
import React, { useEffect, useLayoutEffect, useState } from 'react';
import ReactCodeInput from 'react-code-input';
import { useSelector } from "react-redux";
import { Card, CardHeader, Row, Col, Button, CardBody, ButtonGroup } from 'reactstrap';
import { ApplicationState } from '../../store';
import useCheckRepPin from '../../lib/hooks/useCheckRepPin';

interface RepLogonPinScreenProps {
    setLock: Function;
}
  
const numberOfDigitsInPin = 4;
export const GetNumberOfDigitsInRepPinCode = () => {
    return numberOfDigitsInPin;
}

//allows you to use the setLock function outside of this component to lock the screen, only works if the component has been rendered before so this is done for all rep users on logon / refresh of screen
export let setLockExternal: Function;


  const RepLogonPinScreen: React.SFC<RepLogonPinScreenProps> = (props: RepLogonPinScreenProps) => {
    const { setLock } = props;
    setLockExternal = props.setLock;
    const [enteredPinNumber, setEnteredPinNumber] = useState('');
    const {postCheckPinNumber, pinCheckIsProcessing, pinCheckMatched, requestEndedWithError} = useCheckRepPin();


    //use effect to call the end point to check the pin when the pin changes & is (e.g.) 4 chars long
    useEffect( () => {
        if(enteredPinNumber.length == numberOfDigitsInPin){
            postCheckPinNumber(enteredPinNumber);
        }
    }, [enteredPinNumber])

    //use effect that listens to the result of posting the pin to check it is correct, that unlocks the screen on success
    //doesn't handle display error message though on incorrect pin, this is handled in the hook - a dependency is created below in the UI to display th
    useEffect ( () => {
        if(pinCheckMatched){
            setLock(!pinCheckMatched)
        }
        else{
            setEnteredPinNumber('');
            setLock(!pinCheckMatched)
        }
    }, [pinCheckMatched])



    //#region extra props for pin component if needed
    // const reactCodeInputProps = {
    //     // className: reactCodeInput,
    //     inputStyle: {
    //       fontFamily: 'monospace',
    //       margin:  '4px',
    //       MozAppearance: 'textfield',
    //       width: '15px',
    //       borderRadius: '3px',
    //       fontSize: '14px',
    //       height: '26px',
    //       paddingLeft: '7px',
    //       backgroundColor: 'black',
    //       color: 'lightskyblue',
    //       border: '1px solid lightskyblue'
    //     },
    //     inputStyleInvalid: {
    //       fontFamily: 'monospace',
    //       margin:  '4px',
    //       MozAppearance: 'textfield',
    //       width: '15px',
    //       borderRadius: '3px',
    //       fontSize: '14px',
    //       height: '26px',
    //       paddingLeft: '7px',
    //       backgroundColor: 'black',
    //       color: 'red',
    //       border: '1px solid red'
    //     }
    //   }
    //#endregion
    
    return (
        <div className='react-lock-screen__ui'>
            <div className='react-lock-screen__ui_content'>
                <br/>
                <ReactCodeInput name={''} inputMode={'tel'} type='password' fields={numberOfDigitsInPin} onChange={ setEnteredPinNumber} value={enteredPinNumber}/>
                <br/>
                {
                    !requestEndedWithError
                        ? <> <br/></>
                    : 
                          <div style={{color: 'red'}}>Incorrect PIN</div>
                }
                <div>Enter PIN to Unlock</div>
                
            </div>
        </div>
        
    )
  } 
  export default RepLogonPinScreen;